module.exports = __webpack_public_path__ + "static/media/bloop.10b26f21.svg";